// extracted by mini-css-extract-plugin
export default {"layout":"AppLayout_layout__6gVVc","mainContent":"AppLayout_mainContent__Do9UB","mainContentClosed":"AppLayout_mainContentClosed__9wX2o","content":"AppLayout_content__9EBQD"};